module.exports = __webpack_public_path__ + "static/img/ios_fr.0afab602.png";